import { controls, currencyToNumber, grouped } from "../../controls";

const rpsl7 = {
  label: "Acp Disbursement SLBC",
  starting: true,
  url: "rpsl7",
  pageLabel: "Acp Disbursement SLBC",
  pageType: "history",
  // filteraction: true,
  filter: [
    ...controls.displayText({ tab: "filter", label: "Reporting Season", star: true }),
    ...controls.autoComplete({ tab: "filter", name: "manual_report_master_code", width: "col-sm-2", controlType: "ManualReportMaster" }),
    ...controls.displayText({ tab: "filter", label: "" }),
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Acp Disbursement SLBC",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: {
      pageSize: "A4", pageOrientation: "portrait"
    },
    textReportProps: {
      'slbc': {
        filename: `Acp Disbursement.txt`,
        format: {},
        separator: "|"
      },
    },


    displayColumns: [

      {
        Header: "State Code",
        accessor: "slbc_state_no",

      },

      {
        Header: "District Code",
        accessor: "slbc_district_no",

      },
      {
        Header: "Block Code",
        accessor: "slbc_block_code",
      },
      {
        Header: "farmCr Crop loan No.from 1st April to end of Current Quarter",
        accessor: "farmCr_crop_loan_no"

      },
      {
        Header: "farmCr Crop loan Amount from 1st April to end of Current Quarter",
        accessor: "farmCr_crop_loan_amt",
        type: "currency"
      },
      {
        Header: "farmCr Term loan No. from 1st April to end of Current Quarter",
        accessor: "farmCr_term_loan_no"
      },
      {
        Header: "farmCr Term loan Amount from 1st April to end of Current Quarter",
        accessor: "farmCr_term_loan_amt",
        type: "currency"
      },


      {
        Header: "Agri. Infra No.from 1st April to end of Current Quarter",
        accessor: "agri_infra_no"

      },
      {
        Header: "Agri.Infra Amount from 1st April to end of Current Quarter",
        accessor: "agri_infra_amt",
        type: "currency"
      },

      {
        Header: "Ancilllary. Activities No.from 1st April to end of Current Quarter",
        accessor: "ancillary_activities_no"

      },
      {
        Header: "Ancilllary. Amount from 1st April to end of Current Quarter",
        accessor: "ancillary_activities_amt",
        type: "currency"
      },
      {
        Header: "Micro Ent.  No. from 1st April to end of Current Quarter",
        accessor: "micro_ent_no"

      },
      {
        Header: "Micro Ent. Amount from 1st April to end of Current Quarter",
        accessor: "micro_ent_amt",
        type: "currency"
      },
      {
        Header: "Small Ent. No. from 1st April to end of Current Quarter",
        accessor: "small_ent_no"

      },
      {
        Header: "Small Ent. Amount from 1st April to end of Current Quarter",
        accessor: "small_ent_amt",
        type: "currency"
      },

      {
        Header: "Medium Ent. No. from 1st April to end of Current Quarter",
        accessor: "medium_ent_no"

      },
      {
        Header: "Medium Ent. Amount from 1st April to end of Current Quarter",
        accessor: "medium_ent_amt",
        type: "currency"
      },

      {
        Header: "Other under MSMEs No. from 1st April to end of Current Quarter",
        accessor: "other_msmes_no"

      },
      {
        Header: "Other Under MSMEs Amount from 1st April to end of Current Quarter",
        accessor: "other_msmes_amt",
        type: "currency"
      },
      {
        Header: "Export Cr. No. from 1st April to end of Current Quarter",
        accessor: "export_cr_no"

      },
      {
        Header: "Export Cr. Amount from 1st April to end of Current Quarter",
        accessor: "export_cr_amt",
        type: "currency"
      },

      {
        Header: "Education (PS) No. from 1st April to end of Current Quarter",
        accessor: "education_ps_no"

      },
      {
        Header: "Education (PS) Amount from 1st April to end of Current Quarter",
        accessor: "education_ps_amt",
        type: "currency"
      },

      {
        Header: "Housing (PS) No. from 1st April to end of Current Quarter",
        accessor: "housing_ps_no"

      },
      {
        Header: "Housing (PS) Amount from 1st April to end of Current Quarter",
        accessor: "housing_ps_amt",
        type: "currency"
      },

      {
        Header: "Social Infr. No.from 1st April to end of Current Quarter",
        accessor: "social_infr_no"

      },
      {
        Header: "Social Infr. Amount from 1st April to end of Current Quarter",
        accessor: "social_infr_amt",
        type: "currency"
      },

      {
        Header: "Renewable Energy No.from 1st April to end of Current Quarter",
        accessor: "renewable_energy_no"

      },
      {
        Header: "Renewable Energy Amount from 1st April to end of Current Quarter",
        accessor: "renewable_energy_amt",
        type: "currency"
      },

      {
        Header: "Other Proirity No.from 1st April to end of Current Quarter",
        accessor: "other_proirity_no"

      },
      {
        Header: "Other Proirity Amount from 1st April to end of Current Quarter",
        accessor: "other_proirity_amt",
        type: "currency"
      },

      {
        Header: "Loans to weaker sections under PS No. from 1st April to end of Current Quarter",
        accessor: "loans_to_weaker_ps_no"

      },
      {
        Header: "Loans to weaker sections under PS Amount from 1st April to end of Current Quarter",
        accessor: "loans_to_weaker_ps_amt",
        type: "currency"
      },

      {
        Header: "Agricultre (NPS) No. from 1st April to end of Current Quarter",
        accessor: "agri_nps_no"

      },
      {
        Header: "Agricultre (NPS) Amount from 1st April to end of Current Quarter",
        accessor: "agri_nps_amt",
        type: "currency"
      },

      {
        Header: "Education (NPS) No. from 1st April to end of Current Quarter",
        accessor: "education_nps_no"

      },
      {
        Header: "Education (NPS) Amount from 1st April to end of Current Quarter",
        accessor: "education_nps_amt",
        type: "currency"
      },
      {
        Header: "Housing (NPS) No. from 1st April to end of Current Quarter",
        accessor: "housing_nps_no"

      },
      {
        Header: "Housing (NPS) Amount from 1st April to end of Current Quarter Amt",
        accessor: "housing_nps_amt",
        type: "currency"
      },
      {
        Header: "Personal Loans undeer NPS No.from 1st April to end of Current Quarter",
        accessor: "personal_loans_nps_no"

      },
      {
        Header: "Personal Loans undeer NPS Amount from 1st April to end of Current Quarter",
        accessor: "personal_loans_nps_amt",
        type: "currency"
      },

      {
        Header: "Other NPS No. from 1st April to end of Current Quarter",
        accessor: "other_nps_no"

      },
      {
        Header: "Other NPS Amount from 1st April to end of Current Quarter ",
        accessor: "other_nps_amt",
        type: "currency"
      },
    ]
  }
};

export default rpsl7;